export default class CartDTO {
  constructor(itens = [], valorCompra = 0, valorFrete = 0, valorTotal = 0) {
    this.itens = itens;
    this.valorCompra = valorCompra;
    this.valorFrete = valorFrete;
    this.valorTotal = valorTotal;
  }
}
